
































































import Vue from 'vue';
import IntegrationCallResourceViewModel from '../../../../services/viewModel/resource/IntegrationCallResourceViewModel';
import IpTableColumn from '../../../../components/p-table/IpTableColumn';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: {
    'layout-hostadmin': Vue.$auth.isInRole('hostadmin'),
    _hostadmin: Vue.$auth.isInRole('hostadmin'),
    'layout-admin': Vue.$auth.isInRole('admin'),
  },
  data: () => ({
    objectJsonExpanded: false,
    columns: [
      { value: Vue.$t('core.page.integrationlog.listDetail.id'), field: 'id' },
      { value: Vue.$t('core.page.integrationlog.listDetail.nr'), field: 'number', textAlign: 'right' },
      { value: Vue.$t('core.page.integrationlog.listDetail.name'), field: 'name' },
      { value: Vue.$t('core.page.integrationlog.listDetail.target'), field: 'targetAppSystemName' },
      { value: Vue.$t('core.page.integrationlog.listDetail.applies'), field: 'isOperative' },
      { value: Vue.$t('core.page.integrationlog.listDetail.success'), field: 'isSuccess' },
      { value: Vue.$t('core.page.integrationlog.listDetail.message'), field: 'message' },
    ] as IpTableColumn[],
    isLoading: false,
    areStepsLoading: false,
    integrationDetail: {} as IntegrationCallResourceViewModel,
    linkError: (undefined as string | undefined),
    list: {},
    steps: [] as any[],
    id: Number as unknown | undefined,
  }),
  computed: {
    objectJsonHTML() {
      return JSON.stringifyToHTML(this.integrationDetail?.integrationObject);
    },
    title() {
      return this.integrationDetail.integrationTaskName ?? this.$t('core.page.integrationlog.integrationDetailTitle');
    },
  },
  async mounted() {
    this.areStepsLoading = true;
    this.isLoading = true;
    try {
      const { id } = this.$router.currentRoute.params;
      this.id = id;
      const responseIntegrationLog = await this.$service.api.core.integrationCalls.getIntegrationCallById(id as any);
      this.integrationDetail = responseIntegrationLog;
      if (this.integrationDetail.modifierName === null || this.integrationDetail.modifierName === '') {
        this.integrationDetail.modifierName = 'None';
      }
      if (this.integrationDetail.integrationStatusMessage === null || this.integrationDetail.integrationStatusMessage === '') {
        this.integrationDetail.integrationStatusMessage = 'Success';
      }
      const responseIntegrationSteps = await this.$service.api.core.integrationCalls.getIntegrationCallStepsByCallId(id as any);
      this.steps = responseIntegrationSteps.items.map((e : any) => ({ ...e.toDTO() }));
    } catch (error: any) {
      this.linkError = error;
    }
    this.isLoading = false;
    this.areStepsLoading = false;
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
});
